import { CreditCard } from "@/api/credit-cards/credit-cards";

export const AVS_REAUTH_CUTOFF_DATE = new Date("2026-06-15T00:00:00.000Z");

export const AVS_REAUTH_MESSAGE =
	"Security update: your card details may need to be re-entered. If you added your card before May 15, 2026, remove it and add it back so it keeps working.";

export function cardRequiresAvsReauth(card: CreditCard): boolean {
	if (!card.created_datetime) return true;

	return new Date(card.created_datetime) < AVS_REAUTH_CUTOFF_DATE;
}
